// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const OperationscatalogSeverity = {
  SeverityInfo: 'info',
  SeverityWarning: 'warning',
  SeverityDanger: 'danger',
} as const;
export type OperationscatalogSeverity =
  (typeof OperationscatalogSeverity)[keyof typeof OperationscatalogSeverity];

export function instanceOfOperationscatalogSeverity(value: any): boolean {
  for (const key in OperationscatalogSeverity) {
    if (Object.prototype.hasOwnProperty.call(OperationscatalogSeverity, key)) {
      if (
        OperationscatalogSeverity[
          key as keyof typeof OperationscatalogSeverity
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationscatalogSeverityFromJSON(
  json: any,
): OperationscatalogSeverity {
  return OperationscatalogSeverityFromJSONTyped(json, false);
}

export function OperationscatalogSeverityFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogSeverity {
  return json as OperationscatalogSeverity;
}

export function OperationscatalogSeverityToJSON(
  value?: OperationscatalogSeverity | null,
): any {
  return value as any;
}

export function OperationscatalogSeverityToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationscatalogSeverity {
  return value as OperationscatalogSeverity;
}
